import { render, staticRenderFns } from "./tabSetting.vue?vue&type=template&id=0c6f476e&scoped=true&"
import script from "./tabSetting.vue?vue&type=script&lang=js&"
export * from "./tabSetting.vue?vue&type=script&lang=js&"
import style0 from "./tabSetting.vue?vue&type=style&index=0&id=0c6f476e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f476e",
  null
  
)

export default component.exports